module.exports = __webpack_public_path__ + "img/devices.7f2d6227.png";